import { render, staticRenderFns } from "./Download.vue?vue&type=template&id=d49b522c&scoped=true&"
import script from "./Download.vue?vue&type=script&lang=js&"
export * from "./Download.vue?vue&type=script&lang=js&"
import style0 from "./Download.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Download.vue?vue&type=style&index=1&id=d49b522c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d49b522c",
  null
  
)

export default component.exports